import fetchAPI from '../utils/service';

import { isArticleManager, isAdmin } from '../utils/roles';

function getUserArticlesRequest() {
  return {
    type: 'GET_USER_ARTICLES_REQUEST',
  };
}
function getUserArticlesSuccess(payload) {
  return {
    type: 'GET_USER_ARTICLES_SUCCESS',
    payload,
  };
}
function getUserArticlesFailure() {
  return {
    type: 'GET_USER_ARTICLES_FAILURE',
  };
}

function getUserArticles() {
  return async (dispatch, getState) => {
    dispatch(getUserArticlesRequest());
    try {
      let endpoints = '/article';
      const { role } = getState().user.info;
      if (isArticleManager(role) || isAdmin(role)) {
        endpoints = '/article/list';
      }
      const res = await fetchAPI({
        endpoints,
        params: {
          limit: 1000,
        },
      });
      if (res.status === 200) {
        dispatch(getUserArticlesSuccess(res.data));
      } else {
        dispatch(getUserArticlesFailure());
      }
    } catch (error) {
      dispatch(getUserArticlesFailure());
    }
  };
}

function getDetailArticleRequest() {
  return {
    type: 'GET_DETAIL_ARTICLE_REQUEST',
  };
}
function getDetailArticleSuccess(payload) {
  return {
    type: 'GET_DETAIL_ARTICLE_SUCCESS',
    payload,
  };
}
function getDetailArticleFailure() {
  return {
    type: 'GET_DETAIL_ARTICLE_FAILURE',
  };
}

function getDetailArticle(id) {
  return async (dispatch) => {
    dispatch(getDetailArticleRequest());
    try {
      const res = await fetchAPI({
        endpoints: `/article/detail/${id}`,
      });
      if (res.status === 200) {
        dispatch(getDetailArticleSuccess(res.data));
      } else {
        dispatch(getDetailArticleFailure());
      }
    } catch (error) {
      dispatch(getDetailArticleFailure());
    }
  };
}

function getAnnouncementsRequest() {
  return {
    type: 'GET_ANNOUCEMENTS_REQUEST',
  };
}
function getAnnouncementsSuccess(payload) {
  return {
    type: 'GET_ANNOUCEMENTS_SUCCESS',
    payload,
  };
}
function getAnnouncementsFailure() {
  return {
    type: 'GET_ANNOUCEMENTS_FAILURE',
  };
}

function getAnnouncements(limit) {
  return async (dispatch) => {
    dispatch(getAnnouncementsRequest());
    try {
      const res = await fetchAPI({
        endpoints: '/article/announcements',
        params: limit && { limit },
      });
      if (res.status === 200) {
        dispatch(getAnnouncementsSuccess(res.data));
      } else {
        dispatch(getAnnouncementsFailure());
      }
    } catch (error) {
      dispatch(getAnnouncementsFailure());
    }
  };
}

function getCategoryArticlesRequest(payload) {
  return {
    type: 'GET_CATEGORY_ARTICLES_REQUEST',
    payload,
  };
}
function getCategoryArticlesSuccess(payload) {
  return {
    type: 'GET_CATEGORY_ARTICLES_SUCCESS',
    payload,
  };
}
function getCategoryArticlesFailure(payload) {
  return {
    type: 'GET_CATEGORY_ARTICLES_FAILURE',
    payload,
  };
}

function getCategoryArticles(category) {
  return async (dispatch) => {
    dispatch(getCategoryArticlesRequest({ category }));
    try {
      const res = await fetchAPI({
        endpoints: '/article/list',
        params: { category },
      });
      if (res.status === 200) {
        dispatch(getCategoryArticlesSuccess({ category, ...res.data }));
      } else {
        dispatch(getCategoryArticlesFailure({ category }));
      }
    } catch (error) {
      dispatch(getCategoryArticlesFailure({ category }));
    }
  };
}

function createArticleRequest() {
  return {
    type: 'CREATE_ARTICLE_REQUEST',
  };
}
function createArticleSuccess(data) {
  return {
    type: 'CREATE_ARTICLE_SUCCESS',
    payload: {
      data,
    },
  };
}
function createArticleFailure() {
  return {
    type: 'CREATE_ARTICLE_FAILURE',
  };
}

function createArticle({ data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(createArticleRequest());
    try {
      const res = await fetchAPI({
        method: 'POST',
        data,
        endpoints: '/article',
      });
      if (res.status === 201) {
        dispatch(createArticleSuccess(res.data));
        response.success();
      } else {
        dispatch(createArticleFailure());
        response.failure();
      }
    } catch (error) {
      console.log(error);
      dispatch(createArticleFailure());
      response.failure(error.message);
    }
  };
}

function editArticleRequest() {
  return {
    type: 'EDIT_ARTICLE_REQUEST',
  };
}
function editArticleSuccess(data, _id) {
  return {
    type: 'EDIT_ARTICLE_SUCCESS',
    payload: {
      data,
      _id,
    },
  };
}
function editArticleFailure() {
  return {
    type: 'EDIT_ARTICLE_FAILURE',
  };
}

function editArticle({ _id, data, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(editArticleRequest());
    try {
      const res = await fetchAPI({
        method: 'PATCH',
        data,
        endpoints: `/article/${_id}`,
      });
      if (res.status === 200) {
        dispatch(editArticleSuccess(res.data, _id));
        response.success();
      } else {
        dispatch(editArticleFailure());
        response.failure();
      }
    } catch (error) {
      dispatch(editArticleFailure());
      response.failure();
    }
  };
}

function deleteArticleRequest() {
  return {
    type: 'DELETE_ARTICLE_REQUEST',
  };
}
function deleteArticleSuccess(_id) {
  return {
    type: 'DELETE_ARTICLE_SUCCESS',
    payload: {
      _id,
    },
  };
}
function deleteArticleFailure() {
  return {
    type: 'DELETE_ARTICLE_FAILURE',
  };
}

function deleteArticle({ _id, response = { failure: () => {}, success: () => {} } }) {
  return async (dispatch) => {
    dispatch(deleteArticleRequest());
    try {
      const res = await fetchAPI({
        method: 'DELETE',
        endpoints: `/article/${_id}`,
      });
      if (res.status === 200) {
        dispatch(deleteArticleSuccess(_id));
        response.success();
      } else {
        dispatch(deleteArticleFailure());
        response.failure();
      }
    } catch (error) {
      dispatch(deleteArticleFailure());
      response.failure();
    }
  };
}

function logoutArticle() {
  return {
    type: 'LOGOUT',
  };
}

export {
  getUserArticles,
  getAnnouncements,
  getCategoryArticles,
  getDetailArticle,
  createArticle,
  editArticle,
  deleteArticle,
  logoutArticle,
};



// WEBPACK FOOTER //
// ./src/actions/article.js